import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
/**
 * Custom BuildingUser Icon
 *
 * Combines a building icon with a user icon to represent departments.
 * This custom icon is designed to match the Lucide icon style and behavior.
 */ export const BuildingUser = /*#__PURE__*/ forwardRef(({ size = 24, strokeWidth = 2, className = "", ...props }, ref)=>{
    return /*#__PURE__*/ _jsxs("svg", {
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: strokeWidth,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: `lucide lucide-building-user ${className}`,
        ...props,
        children: [
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("mask", {
                    maskUnits: "userSpaceOnUse",
                    id: "building-mask",
                    children: [
                        /*#__PURE__*/ _jsx("rect", {
                            y: "0",
                            width: "24",
                            height: "24",
                            fill: "white"
                        }),
                        /*#__PURE__*/ _jsx("g", {
                            transform: "translate(16,14) scale(0.7)",
                            style: {
                                transform: "translate(15px, 14px) scale(0.7)"
                            },
                            children: /*#__PURE__*/ _jsx("circle", {
                                cx: "12.5",
                                cy: "8.5",
                                r: "6",
                                fill: "black"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("g", {
                mask: "url(#building-mask)",
                transform: "translate(-1,-1) scale(0.8)",
                vectorEffect: "non-scaling-stroke",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12 10h.01"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12 14h.01"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12 6h.01"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M16 10h.01"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M16 14h.01"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M16 6h.01"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8 10h.01"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8 14h.01"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8 6h.01"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M9 22v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"
                    }),
                    /*#__PURE__*/ _jsx("rect", {
                        x: "4",
                        y: "2",
                        width: "16",
                        height: "20",
                        rx: "2"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("g", {
                transform: "translate(9.6,9.3) scale(0.7)",
                vectorEffect: "non-scaling-stroke",
                children: [
                    /*#__PURE__*/ _jsx("circle", {
                        cx: "12",
                        cy: "8",
                        r: "5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M20 21a8 8 0 0 0-16 0"
                    })
                ]
            })
        ]
    });
});
BuildingUser.displayName = "BuildingUser";

//# sourceMappingURL=BuildingUser.js.map